// @flow
import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import {Text} from 'sail/Text';
import Badge from 'sail/Badge';
import './FlowChart.scss';

export const flowChartIcons = {
  authorize: true,
  canceled: true,
  capture: true,
  'card-authentication-line': true,
  'collect-card': true,
  created: true,
  failed: true,
  processing: true,
  'requires-action-line': true,
  'requires-confirmation': true,
  'requires-payment-method': true,
  succeeded: true,
  verified: true,
};

type FlowChartRowBorderType = 'solid' | 'fade' | 'none';
type FlowChartRowType = 'end' | 'indent';
type FlowChartIconType = $Keys<typeof flowChartIcons>;

const createIcon = (icon: FlowChartIconType) => {
  if (!flowChartIcons[icon]) {
    return '';
  }
  /* eslint-disable import/no-dynamic-require */
  // $FlowExpectedError Webpack will take care of the dynamic import for us.
  return require(`docs/images/components/flow-chart/${icon}.svg`).default;
};

type FlowChartRowProps = {|
  title: string,
  image: string,
  icon: FlowChartIconType,
  type?: FlowChartRowType,
  border?: FlowChartRowBorderType,
  badge?: string,
  children: React.Node,
|};

export const FlowChartRow = ({
  title,
  image,
  icon,
  type = '',
  border = '',
  badge = '',
  children,
}: FlowChartRowProps) => {
  return (
    <Box
      direction="row"
      className={classNames(
        'FlowChartRow',
        type && `FlowChartRow-${type}`,
        border && `FlowChartRow-border--${border}`,
      )}
      flex={{
        direction: type === 'vertical' ? 'column' : 'row',
        alignItems: type === 'vertical' ? 'flex-start' : 'center',
      }}
      padding={{bottom: 32}}
      flexBasis={type === 'vertical' ? '50%' : '100%'}
    >
      <Box padding={{left: 32}} style={{position: 'relative'}} flexGrow={2}>
        <img src={createIcon(icon)} className="FlowChartRow-icon" alt="" />
        <Box className={classNames('FlowChartRow-text')} margin={{right: 32}}>
          <Box flex>
            <Text weight="medium" size={16}>
              {title}
            </Text>
            {badge && <Badge color="yellow" label={badge} />}
          </Box>
          {children}
        </Box>
      </Box>
      <Box padding={{vertical: 16}}>
        <img src={image} className="FlowChartRow-image" alt="" />
      </Box>
    </Box>
  );
};
